import random from 'toxilibs/random.js'
import Level from '../core/level.js'

const level = new Level({
    name: 'arrays_position2',
    dependencies: [
        'levels/arrays_position'
    ]
})


const randomLetter = random.unmistakableLetter



level.addQuestion({
    generator: function (q) {
        let a = []
        const l = random.intBetween(3, 7)
        for (let i = 0; i < l; i++) {
            a.push(random.pick(random.intBetween(1, 9), randomLetter()))
        }
        q.addJSCode(
            'let a = ' + q.codeArrayToDisplay(a)
            + '\na.length'
        )
    },
    timeoutTime: 15000,
    errorExpected: true,
    times: 2
})


level.addQuestion({
    generator: function (q) {
        let a = []
        const l = random.intBetween(3, 7)
        for (let i = 0; i < l; i++) {
            a.push(random.pick(random.intBetween(1, 9), randomLetter()))
        }
        q.addJSCode(
            'let a = ' + q.codeArrayToDisplay(a)
            + '\na[' + (a.length - 1) + ']'
        )
    },
    times: 2
})



level.addQuestion({
    generator: function (q) {
        let a = []
        const l = random.intBetween(3, 7)
        for (let i = 0; i < l; i++) {
            a.push(random.pick(random.intBetween(1, 9), randomLetter()))
        }
        q.addJSCode(
            'let a = ' + q.codeArrayToDisplay(a)
            + '\na.length - 1'
        )
    },
    timeoutTime: 15000
})


level.addQuestion({
    generator: function (q) {
        let a = []
        const l = random.intBetween(3, 7)
        for (let i = 0; i < l; i++) {
            a.push(random.pick(random.intBetween(1, 9), randomLetter()))
        }
        q.addJSCode(
            'let a = ' + q.codeArrayToDisplay(a)
            + '\na[a.length - 1]'
        )
    },
    times: 2
})


export default level

